<i
  class="ene-icon icon-column"
  *ngIf="row[columnConfig.id]"
  [ngClass]="row[columnConfig.id] || null"
  [matTooltipDisabled]="!columnConfig.tooltip"
  [matTooltipClass]="['table-tooltip', columnConfig.id + '-tooltip']"
  [matTooltip]="columnConfig.tooltipText"
></i>
